export { CfsPage as default } from '@/components/pages/Ir/Financial/Cfs'
